/* eslint-disable */

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ActivityEventTarget": [
      "CalendarEventResponse",
      "Entity",
      "EntityConnection"
    ],
    "AppliedToplineItemValue": [
      "Address",
      "Email",
      "EntityLanguage",
      "Note",
      "PhoneNumber",
      "SocialProfile",
      "ToplineAge",
      "ToplineAppliedEntityConnections",
      "ToplineAppliedTags",
      "ToplinePreferredLanguage"
    ],
    "Node": [
      "Action",
      "CustomForm"
    ],
    "Tag": [
      "AddressTag",
      "DateTag",
      "NotesTag",
      "NumberTag",
      "ShiftTag",
      "StandardTag"
    ],
    "TagTargetAssociation": [
      "CalendarEventType",
      "EntityConnectionType",
      "EntityType"
    ]
  }
};
      export default result;
    